import script from "./MdContent.vue?vue&type=script&lang=js"
export * from "./MdContent.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__